import { NetworkStatus, useQuery } from "@apollo/client";
import { useContext } from "react";
import { graphql } from "~/gql";
import { NotificationSubscriptionContext } from "../../components/subscriptions/notification-subscription-provider";
import { NotificationType } from "../types";
export const NOTIFICATIONS_QUERY = graphql(/* GraphQL */ `
  query FindNotifications($type: String) {
    notifications(type: $type) {
      id
      matterId
      title
      type
      description
      message
      isParent
    }
  }
`);

export const useFindNotificationsQuery = (type: NotificationType) => {
  const { notificationContext } = useContext(NotificationSubscriptionContext);

  const incomingSubscription =
    notificationContext.alert.loading || notificationContext.standard.loading;

  const { data, refetch, networkStatus } = useQuery(NOTIFICATIONS_QUERY, {
    notifyOnNetworkStatusChange: true,
    variables: {
      type,
    },
  });

  return {
    data,
    loading:
      [NetworkStatus.loading, NetworkStatus.refetch].includes(networkStatus) ||
      incomingSubscription,
    refetch,
  };
};
